import React from "react";
import { ReactComponent as AlertIcon } from "./../images/svg/alert.svg";
import { gettext } from "../adapter";

const LoadError = () => {
  return (
    <div id="object-preloader id-loading" className="object-preloader">
      <div className="object-preloader--content">
        <AlertIcon className="object-preloader--alert-icon text-red" />
        <small>{gettext("Cannot load data, please try again later.")}</small>
      </div>
    </div>
  );
};

export default LoadError;
